import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hoursMinutes',
  standalone: true,
})
export class HoursMinutesPipe implements PipeTransform {
  transform(input: number | null): string {
    if (!input) {
      return '0';
    }

    // we assume the input is seconds
    const minutes = Math.round(input % 60);
    const hours = Math.round(input / 60);

    if (hours > 0) {
      return `${hours} hr ${minutes} min`;
    } else {
      return `${minutes} min`;
    }
  }
}
